var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Aside'),_c('section',{staticClass:"main_section1"},[_c('router-view'),(_vm.$store.state.loading)?_c('loading',{staticClass:"loader"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }